import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useCartContext } from "../context/cart_context";
import AmountButtons from "./AmountButtons";

const AddToCart = ({ product }) => {
  const { addToCart } = useCartContext();
  const { name } = product;

  const [amount, setAmount] = useState(1);

  const increase = () => {
    setAmount((oldAmount) => oldAmount + 1);
  };

  const decrease = () => {
    setAmount((oldAmount) => {
      const tempAmount = oldAmount - 1;
      return tempAmount < 1 ? 1 : tempAmount;
    });
  };

  return (
    <Wrapper>
      <div className="row">
        <AmountButtons
          amount={amount}
          increase={increase}
          decrease={decrease}
        />
        <Link
          to="/cart"
          className="cta"
          onClick={() => addToCart(name, amount, product)}
        >
          Přidat do košíku
        </Link>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  margin-top: 2rem;

  .row {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--clr-accent);
    color: var(--clr-paper);
    text-transform: uppercase;
    font-family: var(--ff-body);
    font-weight: 600;
    letter-spacing: 0.05em;
    padding: 0.95rem 1.75rem;
    border-radius: var(--radius-pill);
    font-size: 0.95rem;
    transition: var(--transition);
    box-shadow: var(--shadow-sm);
    width: 100%;
  }
  .cta:hover {
    background: var(--clr-accent-dark);
    box-shadow: var(--shadow);
    transform: translateY(-1px);
  }
  .cta:active {
    transform: scale(0.99);
  }

  @media (min-width: 600px) {
    .row {
      flex-direction: row;
      align-items: center;
      gap: 1.25rem;
    }
    .cta {
      width: auto;
      max-width: 280px;
      flex: 1;
    }
  }
`;

export default AddToCart;
